import { Fragment, useEffect, useRef, useState } from "react";
import { ConvertToFloat, isValidArray } from "../../../Layout/Common/common";

export const ExportPdfTemplate = ({ pdfData, showPrice = false, showHeader = false }) => {
  const rowStyle = {
    display: "flex",
    flexDirection: "row",
    gap: "10px",
  };
  const titleStyle = {
    fontSize: 20,
    fontWeight: "bold",
    borderBottom: "1px solid #dddddd",
    marginBottom: 20,
    paddingBottom: 12,
    width: "100%",
    backgroundColor: "#dddddd",
    padding: "5px 0px 5px 5px",
  };
  return (
    <Fragment>
      {pdfData && (
        <Fragment>
          <html>
            <body>
              <section style={{ fontFamily: "Arial, sans-serif" }}>
                <div style={{ padding: "20px" }}>
                  {showHeader == true && (
                    <table
                      style={{
                        width: "100%",
                        marginBottom: "20px",
                        borderBottom: "1px solid #dddddd",
                        paddingBottom: "10px",
                        borderCollapse: "collapse",
                      }}
                    >
                      <tbody>
                        <tr>
                          <td style={{ width: "100px" }}>
                            <img src="https://cdn.wes.com.au/wesreact/newui/logo.png" alt="WES" width="94" />
                          </td>
                          <td style={{ width: "210px" }}>
                            <div
                              style={{
                                fontSize: "23px",
                                fontWeight: "bold",
                                borderBottom: "1px solid #dddddd",
                              }}
                            >
                              WES AUSTRALIA
                            </div>
                            <table style={{ width: "100%", marginTop: "10px" }}>
                              <tbody>
                                <tr>
                                  <td style={{ width: "25%", fontWeight: "bold" }}>Web:</td>
                                  <td>www.wes.com.au</td>
                                </tr>
                                <tr>
                                  <td style={{ width: "25%", fontWeight: "bold" }}>Email:</td>
                                  <td>sales@wes.net.au</td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          <td>
                            <table style={{ width: "100%", marginTop: "10px" }}>
                              <tbody>
                                <tr>
                                  <td style={{ width: "25%", fontWeight: "bold" }}>Phone:</td>
                                  <td>+61 2 9797 9866</td>
                                </tr>
                                <tr>
                                  <td style={{ width: "25%", fontWeight: "bold" }}>Fax:</td>
                                  <td>+61 2 9798 0017</td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          <td>
                            <table style={{ width: "100%", marginTop: "10px" }}>
                              <tbody>
                                <tr>
                                  <td style={{ width: "25%", fontWeight: "bold" }}>Address:</td>
                                  <td>
                                    84-90 Parramatta Road,
                                    <br />
                                    Summer Hill, NSW, 2130, Australia
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  )}
                  <table
                    border="0"
                    style={{
                      width: "100%",
                      marginBottom: "20px",
                      borderCollapse: "collapse",
                      minHeight: "300px",
                      maxHeight: "400px",
                    }}
                  >
                    <tbody>
                      <tr>
                        <td
                          style={{
                            width: "50%",
                            verticalAlign: "middle",
                            border: "1px solid #dddddd",
                            textAlign: "center",
                          }}
                        >
                          {isValidArray(pdfData.productImage) && (
                            <img src={pdfData.productImage[0]} style={{ width: "100%" }} />
                          )}
                        </td>
                        <td style={{ width: "2%", border: "none" }}></td>
                        <td
                          style={{
                            width: "45%",
                            verticalAlign: "top",
                            paddingLeft: "20px",
                          }}
                        >
                          <div
                            style={{
                              fontSize: "24px",
                              fontWeight: "bold",
                              borderBottom: "1px solid #dddddd",
                              marginBottom: "20px",
                              paddingBottom: "12px",
                            }}
                          >
                            {pdfData.productCard.productName}
                          </div>
                          <div style={{ marginTop: "10px" }}>
                            <div style={{ padding: "10px 0px", fontSize: "20px" }}>
                              <strong>Code:</strong> {pdfData.productCard.productCode}
                            </div>
                            <div style={{ padding: "10px 0px", fontSize: "20px" }}>
                              <strong>Availability:</strong>{" "}
                              <span
                                style={{ color: "green" }}
                                dangerouslySetInnerHTML={{
                                  __html: pdfData.stockStatusJson?.stockStatus ?? "",
                                }}
                              />
                            </div>
                          </div>
                          {showPrice == true && (
                            <div
                              style={{
                                visibility: showPrice == true ? "" : "hidden",
                              }}
                            >
                              <div
                                style={{
                                  fontSize: "26px",
                                  color: "#000",
                                  marginTop: "10px",
                                  fontWeight: "bold",
                                }}
                              >
                                ${pdfData.productCard.price}
                              </div>

                              {/* Pricing Box */}
                              <div
                                style={{
                                  backgroundColor: "#f82643",
                                  padding: "10px",
                                  marginTop: "20px",
                                  color: "#fff",
                                  maxWidth: "460px",
                                }}
                              >
                                <div
                                  style={{
                                    fontWeight: "bold",
                                    marginBottom: "10px",
                                    textAlign: "center",
                                    fontSize: "18px",
                                  }}
                                >
                                  Pricing Details
                                </div>
                                <table
                                  style={{
                                    width: "100%",
                                    backgroundColor: "#fff",
                                    color: "#000",
                                    borderCollapse: "collapse",
                                  }}
                                >
                                  <thead>
                                    <tr
                                      style={{
                                        fontWeight: "bold",
                                        color: "#606060",
                                        backgroundColor: "#edeef4",
                                        fontSize: "16px",
                                      }}
                                    >
                                      <td style={{ padding: "10px 20px" }}>Qty</td>
                                      <td style={{ padding: "10px 20px" }}>Cost Ex</td>
                                      <td style={{ padding: "10px 20px" }}>Cost Inc</td>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {pdfData.priceTable &&
                                      pdfData.priceTable.map((item, idx) => (
                                        <tr
                                          key={idx}
                                          style={{
                                            fontWeight: "bold",
                                            fontSize: "16px",
                                          }}
                                        >
                                          <td
                                            style={{
                                              padding: "10px 20px",
                                              borderLeft: "1px solid #f2f2f2",
                                              borderBottom: "1px solid #f2f2f2",
                                            }}
                                          >
                                            {item.qty}
                                          </td>
                                          <td
                                            style={{
                                              padding: "10px 20px",
                                              borderBottom: "1px solid #f2f2f2",
                                            }}
                                          >
                                            {ConvertToFloat(item.price2)}
                                          </td>
                                          <td
                                            style={{
                                              padding: "10px 20px",
                                              borderRight: "1px solid #f2f2f2",
                                              borderBottom: "1px solid #f2f2f2",
                                            }}
                                          >
                                            {ConvertToFloat(item.price1)}
                                          </td>
                                        </tr>
                                      ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table
                    border="0"
                    style={{
                      width: "90%",
                      marginBottom: "20px",
                      borderCollapse: "collapse",
                      minHeight: "300px",
                      maxHeight: "400px",
                    }}
                  >
                    <tr>
                      <td colSpan={3}>
                        <table>
                          <tr>
                            {isValidArray(pdfData.productImage) &&
                              pdfData.productImage.map((image, index) => (
                                <td key={index} style={{ width: 55, height: 55 }}>
                                  <img
                                    src={image}
                                    alt=""
                                    style={{
                                      maxWidth: 50,
                                      maxHeight: 50,
                                    }}
                                  />
                                </td>
                              ))}
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                  <div style={{ marginBottom: 15 }}>
                    {pdfData.productCard.feature && pdfData.productCard.feature != "" ? (
                      <table style={{ width: "100%" }}>
                        <tbody>
                          <tr>
                            <td style={{ width: "53%", verticalAlign: "top" }}>
                              <div style={titleStyle}>Description</div>
                              <span
                                style={{ color: "gray" }}
                                dangerouslySetInnerHTML={{
                                  __html: pdfData.productCard.shortDescription
                                    ? pdfData.productCard.shortDescription + "</br>"
                                    : "",
                                }}
                              />
                              <span
                                style={{ color: "black" }}
                                dangerouslySetInnerHTML={{
                                  __html: pdfData.productCard.description,
                                }}
                              />
                            </td>
                            <td style={{ width: "2%" }}></td>
                            <td style={{ width: "45%", verticalAlign: "top" }}>
                              <div style={titleStyle}>Features</div>
                              <span
                                style={{ color: "black" }}
                                dangerouslySetInnerHTML={{
                                  __html: pdfData.productCard.feature,
                                }}
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    ) : (
                      <table style={{ width: "100%" }}>
                        <tbody>
                          <tr>
                            <td style={{ width: "100%", verticalAlign: "top" }}>
                              <div
                                style={{
                                  fontSize: "28px",
                                  fontWeight: "bold",
                                  borderBottom: "1px solid #dddddd",
                                  marginBottom: "20px",
                                  paddingBottom: "12px",
                                  width: "100%",
                                }}
                              >
                                Description
                              </div>
                              <span
                                style={{ color: "gray" }}
                                dangerouslySetInnerHTML={{
                                  __html: pdfData.productCard.shortDescription,
                                }}
                              />
                              <span
                                style={{ color: "black" }}
                                dangerouslySetInnerHTML={{
                                  __html: pdfData.productCard.description,
                                }}
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </div>
                  {/* Technical Details */}
                  <div>
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td colSpan={2}>
                            <div style={titleStyle}>Technical Details</div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div style={{ width: "100%", overflow: "hidden", fontSize: "16px" }}>
                      <div style={{ width: "49%", float: "left", border: "1px solid #ddd" }}>
                        {pdfData.technicalLeftData.map((item, i) => (
                          <div
                            key={i}
                            style={{
                              width: "100%",
                              clear: "both",
                              overflow: "hidden",
                              borderBottom: "1px solid #ddd",
                              background: "#F2F3F6", // 👈 background on ROW
                              boxSizing: "border-box",
                            }}
                          >
                            {/* LEFT COLUMN */}
                            <div
                              style={{
                                width: "45%",
                                float: "left",
                                fontWeight: "bold",
                                padding: "10px",
                                boxSizing: "border-box",
                              }}
                            >
                              {item.DisplayName}
                            </div>

                            {/* RIGHT COLUMN */}
                            <div
                              style={{
                                width: "55%",
                                float: "left",
                                padding: "10px",
                                background: "#fff", // 👈 mask right side
                                boxSizing: "border-box",
                                wordBreak: "break-word",
                              }}
                            >
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: item.Attr_Value,
                                }}
                              />
                            </div>
                          </div>
                        ))}
                      </div>

                      <div style={{ width: "49%", float: "right", border: "2px solid #ddd" }}>
                        {pdfData.technicalRightData.map((item, i) => (
                          <div
                            key={i}
                            style={{
                              width: "100%",
                              clear: "both",
                              overflow: "hidden",
                              borderBottom: "1px solid #ddd",
                              background: "#F2F3F6",
                              boxSizing: "border-box",
                            }}
                          >
                            <div
                              style={{
                                width: "45%",
                                float: "left",
                                fontWeight: "bold",
                                padding: "10px",
                                boxSizing: "border-box",
                              }}
                            >
                              {item.DisplayName}
                            </div>
                            <div
                              style={{
                                width: "55%",
                                float: "left",
                                padding: "10px",
                                background: "#fff",
                                boxSizing: "border-box",
                                wordBreak: "break-word",
                              }}
                            >
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: item.Attr_Value,
                                }}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </body>
          </html>
        </Fragment>
      )}
    </Fragment>
  );
};
